export const formatPrice = (price?: number) => {
    if (!price) {
        return 0
    }
    return Math.floor(price) / 100
}

export const support107 = (version?: string) => {
    if(!version){
        return false;
    }
    return !compareVersion(version,'1.0.7')
}

export const compareVersion = (ver1: string, ver2: string): boolean => {
    const verArr1: string[] = ver1.split('.');
    const verArr2: string[] = ver2.split('.');
    for (let i = 0; i < 3; i++) {
      if (+verArr1[i] > +verArr2[i]) {
        return false;
      } else if (+verArr1[i] < +verArr2[i]) {
        return true;
      } else {
        continue;
      }
    }
    return false;
  };
  